export default __webpack_public_path__ + "static/media/buzzer property bg.14373bb9.svg";